import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOldPhone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="old-phone"><path d="M4.75 6.88158V1.75M4.75 3.75H19.25V17.25C19.25 19.4591 17.4591 21.25 15.25 21.25H8.75C6.54086 21.25 4.75 19.4591 4.75 17.25V3.75ZM7.75 6.75H16.25V14.25H7.75V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconOldPhone;
